import styled from "styled-components";

export const SpinnerParent = styled.div`
  position: relative;
  min-height: 20em;
`;
